export const BASE_GLOSSARY_PATH = '/karriere-ratgeber/themen-a-bis-z';
export const CAREER_HUB_BASE_PATH = '/karriere-ratgeber';
export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#';
